import React from "react";
import { Card, Form, Menu, Dropdown, Row, Col, Result ,Modal} from "antd";
import PropTypes from "prop-types";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { List, OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import FileViewer from "./../../document-viewer/src/components/index";
import "styles/form.css";
import "styles/document-review.css";
import Modals from "components/modals";
import { DOCUMENT_CURRENT_STATUS, DOCUMENT_REJECTION_REASONS, BANK_ACCOUNT_TYPES } from "constants/enums";
import cx from "classnames";
import { BankAccountRecord } from "records/index";
import CompanyService from "services/company-service";

const {confirm} = Modal;

const BANK_FIELDS = new OrderedMap({
    account_type: {
        type: INPUT_TYPES.SELECT,
        options: BANK_ACCOUNT_TYPES.map((value, label) => ({
            value,
            label
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Type",
        className: "form-field fb-33"
    },
    account_holder_name: {
        type: INPUT_TYPES.TEXT,
        options: [],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Holder Name",
        className: "form-field fb-33"
    },
    account_number: {
        type: INPUT_TYPES.TEXT,
        label: "Account Number",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    ifsc_code: {
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "IFSC Code",
        labelProp: "ifsc_code",
        className: "form-field fb-33",
        showSearch: true,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    bank_branch: {
        type: INPUT_TYPES.OBJECT_TEXT,
        label: "Bank Branch Name",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    }
});

class DocumentViewForm extends React.Component {

    state = {
        showDeletionModal: false,
        showRejectionModal: false,
        showForm: false
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    componentDidUpdate() {
        if(Number(this.props.form.getFieldValue("document_type")) === 34 && !this.state.showForm) {
            this.onSelectDocument(34);
        }
        if(Number(this.props.form.getFieldValue("document_type")) !== 34 && this.state.showForm) {
            this.onSelectDocument();
        }
    }

    onSubmit = (event, action, reason, remarks) => {
        event && event.preventDefault();
        if (action === "REJECT") {
            this.props.updateDocument(
                action,
                {
                    ...this.props.file,
                    remarks: remarks ? remarks : reason,
                    document_status: DOCUMENT_CURRENT_STATUS.get("Rejected")
                }

            );
        } else if (action === "DELETE") {
            this.props.updateDocument(
                action,
                {
                    ...this.props.file,
                    remarks: remarks ? remarks : reason,
                    document_status: DOCUMENT_CURRENT_STATUS.get("Rejected"),
                    is_active: false
                }
            );
        } else if (action === "APPROVE") {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    try {
                        const { document_type, ...restValues } = values;
                        let bankDetails = restValues;
                        this.props.updateDocument(
                            action,
                            {
                                ...this.props.file,
                                document: this.props.docMasterList.find((_) => _.id === Number(document_type.includes("-") ? document_type.split("-")[0] : Number(document_type))),
                                document_option : document_type.includes("-") ? Number(document_type.split("-")[1]) : null,
                                // document: this.props.docMasterList.find((_) => _.id === Number(document_type)),
                                document_status: DOCUMENT_CURRENT_STATUS.get("Verified"),
                                parse_data: restValues
                            }
                        );
                        if (bankDetails !== {}) {
                            this.props.updateBankAccounts(new BankAccountRecord(bankDetails).formValues);
                        }
                    } catch (error) {
                        console.error("--> err -> ", error);
                    }
                }
            });
        }
    };

    onSelectDocument = (val) => {
        this.setState({
            showForm: Number(val) === 34 ? true : false
        });
    }

    titleFormFields = new OrderedMap({
        document_type: {
            type: INPUT_TYPES.SELECT,
            placeholder: "Document Type",
            filterOption: (value, option) => {
                if (value) {
                    return (
                        option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                    );
                }
                return true;
            },
            optionFilterProp: "label",
            optionLabelProp: "label",
            dropdownMatchSelectWidth: false,
            onSelect: this.onSelectDocument,
            showSearch: true,
            size: "small",
            style: {},
            onChange : (_) => {
                let docType = _;
                if(docType  && this.props.file && docType != (this.props.file.document_option ? this.props.file.document?.id-this.props.file.document_option : this.props.file.document?.id)){
                    let oldDocumentName = this.props.docMasterList && this.props.docMasterList.filter(_ => _.id == this.props.file.document?.id);
                    let newDocumentName = this.props.docMasterList && this.props.docMasterList.filter(_ => _.id == (docType.includes("-") ? Number(docType.split("-")[0])  : Number(docType)) )[0].document_name || "";
                    let docOption = docType && docType.includes("-")? docType.split("-")[1] : "";
                    confirm({
                        icon : null,
                        title: "Are you sure ?",
                        content: <p>Are you sure you want to change this document from <b>{oldDocumentName[0].document_name} {this.props.file.document_option && this.props.file.document_option == 12 ? "- Front" : this.props.file.document_option == 13 ? "- Back" : "" }</b> to <b>{newDocumentName} {docType.includes("-") && docOption == 12 ? "- Front" :docOption == 13 ?  "- Back" : "" }</b> <br/><br/> <p style={{color : "red"}}> This may impact the case approval !</p></p>,
                        onOk() {
                        },
                        onCancel() {
                        },
                    });
                }
            },
            // options: ,
            rules: [
                {
                    required: true,
                    message: "Document Type is required"
                }
            ],
            className: "mr-5 mb-0"
        }
    });

    renderRejectionModal() {
        return (
            <Modals.RejectionReasonModal
                title={"Document Rejection"}
                visible={this.state.showRejectionModal}
                onCancel={this.closeModal}
                onConfirm={this.submitModal}
                reasonCategories={DOCUMENT_REJECTION_REASONS}
                addRemarks={true}
            />
        );
    }

    renderDeleteModal() {
        return (
            <Modals.RejectionReasonModal
                title={"Document Delete"}
                visible={this.state.showDeletionModal}
                onCancel={this.closeDeleteModal}
                onConfirm={this.submitDeleteModal}
                reasonCategories={DOCUMENT_REJECTION_REASONS}
                addRemarks={true}
            />
        );
    }

    getViewerTitle = () => {
        let baseFields = this.titleFormFields;
        if (!this.props.file) {
            baseFields = baseFields
                .setIn(["document_type", "disabled"], true);
        }
        return (
            <div className={"d-flex"} >
                {baseFields
                    .map((field, fieldName) => {
                        if (fieldName === "document_type") {
                            field.options = List(this.props.docMasterList)
                                .filter((_) => (_.id !== 47))
                                .groupBy((_) => _ && _.document_category && _.document_category.name)
                                .filter((_) => _.size > 0)
                                .map((options) =>
                                    options
                                        .map((__) => {if(__.document_document_type_option.length > 0 && this.props.isOnboardingCase){
                                            let docOptions = __.document_document_type_option.map((docOption) => ({
                                                key: `${__.id}-${docOption.id}`,
                                                value : `${__.id}-${docOption.id}`,
                                                label: docOption.document_type_name,
                                                rest: { label: docOption.document_type_name }
                                            })); 
                                            return  docOptions;                                            
                                        }else{
                                            return { key: __.id,
                                                value: String(__.id),
                                                label: __.document_name,
                                                rest: { label: __.document_name }};
                                        }
                                        })
                                        .toArray().flat()
                                );
                        }
                        return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                    })
                    .toList()
                    .toArray()}
            </div>
        );
    };

    closeDeleteModal = () => {
        this.setState({
            showDeletionModal: false,
            rejectionReason: null
        });
    };

    submitModal = (reason, remarks) => {
        this.setState(
            {
                showRejectionModal: false
            },
            () => {
                this.onSubmit(null, "REJECT", reason, remarks);
            }
        );
    };

    submitDeleteModal = (reason, remarks) => {
        this.setState(
            {
                showDeletionModal: false
            },
            () => {
                this.onSubmit(null, "DELETE", reason, remarks);
            }
        );
    };

    confirmReject = () => {
        this.setState({
            showRejectionModal: true
        });
    };

    confirmDelete = () => {
        this.setState({
            showDeletionModal: true
        });
    };

    actionConfigs = List([
        {
            className: "reject-btn",
            key: "reject",
            label: "Reject",
            onClick: this.confirmReject
        }
    ]);

    isActionBtnDisabled(actionKey) {
        switch (actionKey) {
        case "approve": {
            if (!this.props.file) {
                return true;
            }
            return false;
        }
        case "reject":
            return (
                !this.props.file ||
                (this.props.file && this.props.file.document_status === DOCUMENT_CURRENT_STATUS.get("Rejected"))
            );
        case "delete":
            return !this.props.file;
        default:
            return false;
        }
    }

    menu = () => {
        return (
            <Menu>
                {this.actionConfigs
                    .map((_) => (
                        <Menu.Item
                            key={_.key}
                            size={"small"}
                            className={_.className}
                            onClick={_.onClick}
                            htmlType={_.htmlType || "button"}
                            disabled={this.isActionBtnDisabled(_.key)}>
                            {_.label}
                        </Menu.Item>
                    ))
                    .toArray()}
            </Menu>
        );
    };

    renderFormActions() {
        const docList = List(this.props.docMasterList)
            .filter((_) => (_.id !== 47));
        return (
            <Dropdown.Button
                type={"primary"}
                size={"small"}
                key={"approve"}
                disabled={this.isActionBtnDisabled("approve") || !docList.filter(_=> _.id == this.props.file.document?.id).size}
                onClick={(e) => this.onSubmit(e, "APPROVE")}
                overlay={this.menu}>
                Approve
            </Dropdown.Button>
        );
    }

    get showResult() {
        return (
            <div className={"signzy-form"}>
                <Result status={"404"} subTitle={"Signzy Not Applicable"} />
            </div>
        );
    }

    getValueFromObject = bankBranch => {
        if (!bankBranch) {
            return null;
        }
        return bankBranch.name;
    };

    setBankBranchName = branch => {
        this.props.form.setFieldsValue({
            "bank_branch": branch
        });
    };

    ifscLookup = str =>
        CompanyService.ifscLookup(str).then(({ data }) => ({
            data: data.results
        }));

    get _parserForm() {
        return (
            <div className={cx("form")}>
                {(BANK_FIELDS || Map({}))
                    .map((field, fieldName) => {
                        if(fieldName === "ifsc_code") {
                            field.onSearch = this.ifscLookup;
                            field.onSelect = this.setBankBranchName;
                        }
                        if(fieldName === "bank_branch") {
                            field.getValueFromObject = this.getValueFromObject;
                        }
                        return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                    })
                    .toList()}
            </div>
        );
    }

    renderParserSection() {
        return (
            <Col span={9} className={"p-5 mb-5"}>
                <Card
                    title={"Bank Details Form"}
                    style={{
                        height: "90vh",
                        overflowY: "scroll"
                    }}>
                    {/* {this._isParserApplicable ? this._parserForm : this.showResult} */}
                    {this._parserForm}
                </Card>
            </Col>
        );
    }


    render() {
        return (
            <React.Fragment>
                {this.renderRejectionModal()}
                {this.renderDeleteModal()}
                <Form style={FORM_STYLE}>
                    <Row>
                        <Col className={"p-5 flex-1"} span={this.state.showForm ? 15 : 24}>
                            <Card
                                className={"file-viewer"}
                                title={this.getViewerTitle()}
                                extra={this.renderFormActions()}
                            >
                                <div
                                    key={"file_viewer"}
                                    style={{
                                        height: "80vh"
                                    }}>
                                    <FileViewer
                                        file={this.props.file}
                                        filePath={`${process.env.FILE_DOWNLOAD_URL}/${this.props.selectedFilePath}`}
                                        fileType={this.props.selectedFileType}
                                    />
                                </div>
                            </Card>
                        </Col>
                        {this.state.showForm ?
                            this.renderParserSection()
                            : null
                        }
                    </Row>
                </Form>
            </React.Fragment>
        );
    }
}

const FORM_STYLE = {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
};

DocumentViewForm.propTypes = {
    file: PropTypes.object,
    selectedFilePath: PropTypes.string,
    selectedFileType: PropTypes.string,
    form: PropTypes.object,
    docMasterList: PropTypes.object,
    updateDocument: PropTypes.func,
    updateBankAccounts: PropTypes.func,
    bankAccounts: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ file }) => {
        if(file) {
            const documentType = file.document && String(file.document?.id);
            let data;
            if(file.parse_data && file.parse_data !== [] && file.parse_data !== {}) {
                data = Map({
                    document_type: file.document_option ? `${documentType}-${file.document_option}`: documentType,
                    ...file.parse_data
                });
            } else {
                data = Map({
                    document_type: documentType,
                });
            }
            return data && data.map(_ => {
                return Form.createFormField({
                    value: _,
                });
            }).toJS();
        }
    }
})(DocumentViewForm);